module.exports = __webpack_public_path__ + "static/img/xta.d60e3b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xta.png
// module id = /mbH
// module chunks = 0